import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class TimeZoneService {
  timeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
